import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {BaseListComponent} from '../../abstract/base-list.component';
import {ActivatedRoute, Router} from '@angular/router';
import {PaymentComponent} from '../../paymemtModule/payment/payment.component';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PaymentModel} from '../../data/model/PaymentModel/payment.model';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {BankAccountModel} from '../../data/model/BankAccountModel/bank-account.model';
import {Highlight} from '../../shared/highlights/highlight';
import {Subject} from 'rxjs';
import {AppConstants} from '../../shared/constants/app-constants';
import {debounceTime} from 'rxjs/operators';
import {ApiTokenComponent} from '../../dialogs/api-token/api-token.component';
import {GetBankAccountHistoryListAction} from './get-bank-account-history-list.action';
import {ErrorConstants} from '../../shared/constants/error-constants';
import {RequestDetailsComponent} from '../../dialogs/request-details/request-details.component';
import {ExportModel} from '../../data/model/ExportModel/export-model';
import {ExportConstants} from '../../shared/constants/export-constants';
import {ariaSort, SortDirection} from '../../ui/table/payarc-sort-icon.component';
import {PagerPage} from '../../ui/pager/payarc-pager.component';
import {DetailRow} from '../../ui/detail-card/payarc-detail-card.component';
import {RowDetailDialogComponent, RowDetailDialogData} from '../../ui/row-detail-dialog/row-detail-dialog.component';
import {PayarcStatusBadgeComponent} from '../../ui/status-badge/payarc-status-badge.component';
import {DateonlyPipe} from '../../shared/custom-pipes/date-format-pipe/dateonly.pipe';

@Component({
    selector: 'app-change-request-history',
    templateUrl: './change-request-history.component.html',
    styleUrls: ['./change-request-history.component.css'],
    standalone: false
})
export class ChangeRequestHistoryComponent extends GetBankAccountHistoryListAction implements OnInit, OnDestroy {
  showExport = false;
  exportExcel: ExportModel[] = ExportConstants.bankAccountChangeRequestListExport;
  exportData: object;
  from_date: any;
  to_date: any;
  runActionDialog;
  today: Date = new Date();
  changeRequestList: ApiResponseModel<BankAccountModel>;
  _service_name = '/merchant_bank_accounts/history';
  constructor(private _route: ActivatedRoute, router: Router, private datePipe: DatePipe,
              route: ActivatedRoute,
              private dialog: MatDialog, dataManager: DataManagerService, @Inject(PLATFORM_ID) private platformId: any,
              @Inject('LOCALSTORAGE') private localStorage: any, snackBar: MatSnackBar) {
    super();
    this.exportData = {
      exportServiceName: AppConstants.SERVICE_NAME_EXPORT_DASHBOARD + '/change-request',
      redirectUrl: '/merchant/branding/change-request-history',
      cancelRedirectUrl: '/merchant/branding/change-request-history',
      fileName: 'Payarc_Bank_Account_Change_Request_History_Report',
      heading: 'Bank Account Change Request History',
    };
    this.dataManager = dataManager;
    this.snackBar = snackBar;
    this.changeRequestList = new ApiResponseModel<BankAccountModel>();
    this.searchHits = new Subject<void>();
    this.alertDialog = dialog;
    this.errorMsg = null;
    this.emptyListMsg = ErrorConstants.bankAccountHistoryErrorMsg[0];
    this.route = route;
    this.router = router;
    this.getListUrl = AppConstants.BASE_URL + this._service_name;
  }
  ngOnInit(): void {
    this.searchHits.pipe(debounceTime(600), ).subscribe((res) => {
      if (!this.isNullOrUndefined(this.searchText)) {
        this.setUrl();
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      if (
        !this.localStorage.getItem(this.filter_storage_key) &&
        !this.localStorage.getItem(this.count_storage_key)
      ) {
        this.setUrl();
      }
    }
  }
  limitChange() {
    this.setUrl(1);
  }

  onSearch(value: string) {
    this.searchText = value;
    this.searchHits.next();
  }

  /** Overrides the base no-arg `setUrl()` with an explicit page, so the pager can request
   * any page without the base implementation's implicit reset to page 1. */
  setUrl(page = 1): string {
    let url = this.getListUrl + (isNaN(this.limit) ? '?limit=0' : '?limit=' + this.limit + '&page=' + page);
    if (!this.isNullOrUndefined(this.searchText)) {
      url += '&search=' + this.searchText;
    }
    if (!this.isNullOrUndefined(this.orderBy)) {
      url += '&orderBy=' + this.orderBy + '&sortedBy=' + this.sortBy;
    }
    if (!this.isNullOrUndefined(this.from)) {
      url += '&from_date=' + this.from;
    }
    if (!this.isNullOrUndefined(this.to)) {
      url += '&to_date=' + this.to;
    }
    this.getList(url);
    return url;
  }

  get currentPage(): number {
    return this.metadata?.['current_page'] || 1;
  }

  get totalPages(): number {
    const total = this.metadata?.['total'] || 0;
    return this.limit > 0 ? Math.max(1, Math.ceil(total / this.limit)) : 1;
  }

  get pagerRangeLabel(): string {
    if (!this.metadata?.['total']) {
      return '';
    }
    const start = 1 + (this.currentPage - 1) * this.limit;
    const end = this.currentPage === 1 ? this.metadata['count'] : start + this.metadata['count'] - 1;
    return `Showing ${start}–${end} of ${this.metadata['total']}`;
  }

  get pagerPages(): PagerPage[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) {
      return Array.from({length: total}, (_, i) => i + 1);
    }
    const pages = new Set<number>([1, total, current, current - 1, current + 1]);
    const sorted = [...pages].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
    const out: PagerPage[] = [];
    let prev = 0;
    for (const p of sorted) {
      if (prev && p - prev > 1) {
        out.push('...');
      }
      out.push(p);
      prev = p;
    }
    return out;
  }

  pagerPrev() {
    this.setUrl(Math.max(1, this.currentPage - 1));
  }

  pagerNext() {
    this.setUrl(Math.min(this.totalPages, this.currentPage + 1));
  }

  pagerSelect(page: number) {
    this.setUrl(page);
  }

  sortDirection(key: string): SortDirection {
    if (this.orderBy !== key) { return null; }
    return this.sortBy === 'asc' ? 'asc' : 'desc';
  }

  ariaSort = ariaSort;

  highlight(value) {
    return Highlight.highlight(value, this.searchText);
  }
  /** Unique accessible name for a row: who, when, status and the new account's last 4. */
  historyRowAriaLabel(item: any): string {
    const last4 = String(item.bank_account_number || '').replace(/\D/g, '').slice(-4);
    const parts = [
      'Change request' + (item.requested_by_user_name ? ' by ' + item.requested_by_user_name : ''),
      item.requested_at ? new DateonlyPipe().transform(item.requested_at, 'MM/DD/YYYY') : null,
      item.history_status || null,
      last4 ? 'new account ending ' + last4 : null,
      item.id ? 'ID ' + item.id : null,
    ].filter(Boolean);
    return `${parts.join(', ')}. Open detail`;
  }

  /**
   * Row click / Enter (desktop and mobile - 9 columns scroll sideways even on desktop): the change
   * request in the shared row detail panel. The full request dialog (reason, note, documents, and
   * the merchant's response when Risk pended it) stays one click away: "Respond" when the request
   * waits for the merchant, "View details" otherwise.
   */
  openHistoryDetail(item: any): void {
    const date = (v: any) => (v ? new DateonlyPipe().transform(v, 'MM/DD/YYYY') : '') || '--';
    const rows: DetailRow[] = [
      { label: 'Requested by', value: item.requested_by_user_name || '--' },
      { label: 'Requested date', value: date(item.requested_at) },
      { label: 'Used for', value: item.used_for || '--' },
      { label: 'New routing number', value: item.routing_number || '--' },
      { label: 'New account number', value: item.bank_account_number || '--' },
      { label: 'Old routing number', value: item.old_routing_number || '--' },
      { label: 'Old account number', value: item.old_bank_account_number || '--' },
    ];
    if (item.history_status === 'Update completed' && item.updated_at) {
      rows.push({ label: 'Completed date', value: date(item.updated_at) });
    }
    if (item.reason) {
      rows.push({ label: 'Reason', value: item.reason });
    }
    const variant = Object.assign(new PayarcStatusBadgeComponent(), { status: item.history_status }).resolvedVariant;
    const data: RowDetailDialogData = {
      title: 'Change request',
      rows,
      status: item.history_status ? { label: item.history_status, tone: variant } : undefined,
      action: { label: item.can_respond === true ? 'Respond' : 'View details', run: () => this.reveal(item) },
    };
    this.alertDialog.open(RowDetailDialogComponent, {
      data,
      panelClass: 'pa-shell-dialog',
      width: '560px',
      maxWidth: '94vw',
      maxHeight: '90vh',
      autoFocus: false,
    });
  }

  reveal(item) {
    this.openRevealModal(item);
  }
  async openRevealModal(item) {
    const dialogConfig = new MatDialogConfig();
    // same shell as the row detail panels (was the legacy 1000px 'request-details-dialog')
    dialogConfig.panelClass = 'pa-shell-dialog';
    dialogConfig.width = '560px';
    dialogConfig.maxWidth = '94vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: item.id,
      status: item.history_status,
      requested_at: item.requested_at,
      completed_at: item.history_status === 'Update completed' ? item.updated_at : null,
      reason: item.reason,
      note: item.note,
      upload_link: item.upload_link,
      // PDT-32072 (AC-08): pended requests expose what Risk asked for and accept
      // the merchant's response (note + documents) straight from this dialog.
      can_respond: item.can_respond === true,
      pend_note: item.pend_note,
      pend_documents: item.pend_documents || []
    };
    this.runActionDialog = this.alertDialog.open(RequestDetailsComponent, dialogConfig);
    this.runActionDialog.afterClosed().subscribe((result) => {
      if (result === 'responded') {
        this.showSnackBar('Your response was submitted. Our Risk team will review it shortly.', 'Ok', 5000);
        this.setUrl();
      }
    });
  }
  checkdate() {
    if (!this.isNull(this.from_date) && this.from_date.toString() === 'Invalid Date') {
      this.datereport();
    }
  }

  checkdate2() {

    if (!this.isNull(this.to_date) && this.to_date.toString() === 'Invalid Date') {
      this.datereport();
    }
  }
  clearDates() {
    this.from_date = null;
    this.to_date = null;
    this.datereport();
  }

  datereport() {
    if ((this.from_date && this.from_date.toString() === 'Invalid Date') || (this.to_date && this.to_date.toString() === 'Invalid Date')) {
      this.showSnackBar('Enter valid date.', 'Ok', 3000);
    } else if ((this.isNullOrUndefined(this.from_date)) || this.isNullOrUndefined(this.to_date)) {
      if ((!this.isNullOrUndefined(this.searchText) && (this.isNull(this.from_date) && this.isNull(this.to_date)))
        || (this.isNullOrUndefined(this.searchText) && (this.isNull(this.from_date) && this.isNull(this.to_date)))) {
        this.from = null;
        this.to = null;
        this.setUrl();

      } else {
        return;
      }
    } else if (this.from_date > this.to_date) {
      this.showSnackBar('From date should not exceed ' + this.datePipe.transform(this.to_date, 'MM/dd/yyyy') + '.', 'Ok', 3000);
    } else {
      this.from = (this.isNullOrUndefined(this.from_date) ? '' : (this.datePipe.transform(this.from_date, 'yyyy-MM-dd')));
      this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
      this.from = new Date(this.from + ' 00:00:00').toISOString();

      this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
      this.to = new Date(this.to + ' 23:59:59').toISOString();
      this.setUrl();
    }
  }
  protected getListErr(err) {
    this.errorMsg = this.networkErrorHandler(err.error, ErrorConstants.bankAccountHistoryErrorMsg) || err.error?.message || 'Something went wrong.';
  }
  protected getListRes(bankAccountHistoryListResponse: ApiResponseModel<BankAccountModel>) {
    this.changeRequestList = bankAccountHistoryListResponse;
    this.metadata = bankAccountHistoryListResponse.meta.pagination;
    if (this.changeRequestList.data.length === 0) {
      this.errorMsg = ErrorConstants.bankAccountHistoryErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }

  openexcel(): void {
    this.showExport = true;
    this.exportData['include'] = '&full_path=App\\Containers\\AppSection\\ChangeRequest\\Data\\Repositories\\&is_full_path=1';
  }
}
